import themable from './_themable'

export const BaseTile = themable('BaseTile', {})
export default BaseTile
